import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=32225d74&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=js&"
export * from "./payments.vue?vue&type=script&lang=js&"
import style0 from "./payments.vue?vue&type=style&index=0&lang=css&"
import style1 from "./payments.vue?vue&type=style&index=1&id=32225d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32225d74",
  null
  
)

export default component.exports